export default __webpack_public_path__ + "static/media/3.862b7a70.png";